// ======== COMPLETE GEURKALENDER.JS v19 - ALLE FIXES ========
// 🔥 FIXED: Cache invalidation + Server labels voor subscribers + UTC lock cutoffs

// =========================================================
// 🚨 SAFARI BFCACHE FIX
// Zorgt dat Safari de pagina hard ververst als hij uit de cache komt.
// =========================================================
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    console.warn('[Geurkalender] Safari bfcache restore detected → forcing reload');
    window.location.reload();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('geurkalender-modal');
  const closeBtn = document.getElementById('close-geurkalender');
  if (!modal) return;

  const API_BASE = (function() {
    const fallback = 'https://smellish-auth.onrender.com';
    try {
      if (typeof window.smellishGetApiBase === 'function') {
        return window.smellishGetApiBase();
      }
      const fromWindow = (window.SMELLISH_API_BASE || '').trim().replace(/\/$/, '');
      if (fromWindow) return fromWindow;
      const meta = document.querySelector('meta[name="smellish-api-base"]');
      if (meta && meta.content) return meta.content.trim().replace(/\/$/, '');
    } catch (_) {}
    return fallback;
  })();
  const monthNames = ["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"];
  const HINT_KEY = 'gk_drag_hint_shown';
  const CAL_DEBUG = Boolean(window.SMELLISH_DEBUG_LOGS);
  const calLog = (...args) => { if (CAL_DEBUG) console.log(...args); };
  const calWarn = (...args) => { if (CAL_DEBUG) console.warn(...args); };
  const calError = (...args) => { if (CAL_DEBUG) console.error(...args); };

  window.smDebugShowDay = !!window.smDebugShowDay;

  let cachedVersion = null;
  let lastVersionCheck = 0;
  const VERSION_CACHE_TTL = 60000; // 1 minute cache

  // Login context
  const LOGGED_IN = !!window.smCustomerLoggedIn;
  const CUSTOMER_ID = window.smCustomerId || null;
  const SERVER_OK = LOGGED_IN && !!CUSTOMER_ID;
  const IS_SUBSCRIBER = SERVER_OK && (window.smCustomerCycle === '1' || window.smCustomerCycle === '15');

  // 🎁 Gift subscription blokkade (met localStorage cache voor instant load)
  const GIFT_CACHE_KEY = CUSTOMER_ID ? `gk_gift_status_${CUSTOMER_ID}` : null;
  const BLOCKED_CACHE_KEY = CUSTOMER_ID ? `gk_blocked_variants_${CUSTOMER_ID}` : null;

  // Load from cache first (instant!)
  let isGiftSubscription = false;
  let blockedVariantIds = new Set();

  // 🔥 Instant load from cache
  (function loadGiftCacheInstant() {
    if (!GIFT_CACHE_KEY) return;
    try {
      const cachedGift = localStorage.getItem(GIFT_CACHE_KEY);
      const cachedBlocked = localStorage.getItem(BLOCKED_CACHE_KEY);

      if (cachedGift === 'true') {
        isGiftSubscription = true;
        if (cachedBlocked) {
          blockedVariantIds = new Set(JSON.parse(cachedBlocked));
          calLog('[GIFT] Loaded from cache:', blockedVariantIds.size, 'blocked variants');
        }
      }
    } catch(_) {}
  })();

  // 🔥 JWT RAM-cache voor snellere API calls
  let _jwtTokenCache = null;

  function clearJwtCache() {
    _jwtTokenCache = null;
    calLog('[AUTH] JWT cache cleared');
  }

  async function getJwtToken() {
    // Return cached token if available
    if (_jwtTokenCache) {
      return _jwtTokenCache;
    }

    // 🔐 Priority 1: Use pre-fetched token from theme.liquid (fastest path)
    if (window.smellishAuthToken) {
      _jwtTokenCache = window.smellishAuthToken;
      return _jwtTokenCache;
    }

    // 🔐 Priority 2: Wait for pre-fetch promise if available
    if (window.smellishAuthTokenPromise) {
      try {
        _jwtTokenCache = await window.smellishAuthTokenPromise;
        return _jwtTokenCache;
      } catch (e) {
        calLog('[AUTH] Token promise failed, falling back:', e);
      }
    }

    // 🔐 Priority 3: Fallback - Fetch new token and cache it
    if (CUSTOMER_ID && typeof window.getCustomerJWTToken === 'function') {
      _jwtTokenCache = await window.getCustomerJWTToken(CUSTOMER_ID);
      return _jwtTokenCache;
    }
    return `customer_${CUSTOMER_ID}`;
  }

  async function getAuthHeaders() {
    const headers = { 'Content-Type': 'application/json' };
    if (CUSTOMER_ID) {
      headers['X-Shopify-Customer-Token'] = await getJwtToken();
    }
    return headers;
  }

  async function getCacheHeaders() {
    const headers = {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json'
    };
    if (CUSTOMER_ID) {
      headers['X-Shopify-Customer-Token'] = await getJwtToken();
    }
    return headers;
  }

  // localStorage keys
  const GUEST_KEY = 'geurkalender_guest';
  const USER_KEY = CUSTOMER_ID ? ('geurkalender__' + CUSTOMER_ID) : null;
  const ACTIVE_KEY = USER_KEY || GUEST_KEY;
  const LAST_UID_KEY = 'gk_last_uid';
  const LABELS_CACHE_KEY = CUSTOMER_ID ? ('gk_labels_' + CUSTOMER_ID) : null;
  const LAST_REFRESH_KEY = CUSTOMER_ID ? ('gk_last_refresh_' + CUSTOMER_ID) : null;

  // updatedAt tracking
  const UPDATED_KEY = CUSTOMER_ID ? ('geurkalender_updated__' + CUSTOMER_ID) : 'geurkalender_guest_updated';
  const UPDATED_MS_KEY = UPDATED_KEY + '__ms';
  const readUpdatedISO = () => { try { return localStorage.getItem(UPDATED_KEY) || null; } catch(_) { return null; } };
  const readUpdatedMS  = () => { try { return parseInt(localStorage.getItem(UPDATED_MS_KEY)||'0',10) || 0; } catch(_) { return 0; } };
  const writeUpdated   = (iso, ms) => { try { if (iso) localStorage.setItem(UPDATED_KEY, iso); if (ms>0) localStorage.setItem(UPDATED_MS_KEY, String(ms)); } catch(_) {} };
  const tsNum = (ts) => { const n = Date.parse(ts); return Number.isFinite(n) ? n : 0; };

// 🔥 FIXED: Check of lokale data 'over de datum' is t.o.v. het lock-moment
// Fix: Berekent nu correct het LAATSTE lock moment (ook als dat in vorige maand was)
function isLocalDataExpired() {
  const lastUpdate = readUpdatedMS();
  if (!lastUpdate) return true;

  const now = new Date();
  const cycle = window.smCustomerCycle || '15';
  const lockDay = cycle === '15' ? 6 : 22;

  // Bereken het LAATSTE lock moment dat GEPASSEERD is
  // We nemen 21:00 uur lokale tijd als veilige grens (Cron = 20:00 UTC)
  let lockMoment = new Date(now);
  lockMoment.setHours(21, 0, 0, 0);
  lockMoment.setDate(lockDay);

  // Als lockMoment in de toekomst ligt, pak vorige maand
  if (lockMoment > now) {
    lockMoment.setMonth(lockMoment.getMonth() - 1);
  }

  // Check of data van vóór de laatste lock is
  if (lastUpdate < lockMoment.getTime()) {
    calLog('[CACHE] Data is van voor de lock (Expired) -> Force Refresh');
    return true;
  }

  // Extra veiligheid: Data ouder dan 20 dagen altijd verversen
  if ((now.getTime() - lastUpdate) > (20 * 24 * 60 * 60 * 1000)) {
      return true;
  }
  return false;
}

  // 🔥 NIEUW: Cache invalidation helpers
  const readCachedLabels = () => { 
    if (!LABELS_CACHE_KEY) return null;
    try { 
      const cached = sessionStorage.getItem(LABELS_CACHE_KEY);
      return cached ? JSON.parse(cached) : null;
    } catch(_) { 
      return null; 
    } 
  };
  
  const writeCachedLabels = (labels) => { 
    if (!LABELS_CACHE_KEY || !labels) return;
    try { 
      sessionStorage.setItem(LABELS_CACHE_KEY, JSON.stringify(labels)); 
    } catch(_) {} 
  };

  const clearCachedLabels = () => {
    if (!LABELS_CACHE_KEY) return;
    try {
      sessionStorage.removeItem(LABELS_CACHE_KEY);
      calLog('[CACHE] Labels cleared');
    } catch(_) {}
  };

  // 🔥 NIEUW: Check of we binnen lock window zitten (2u na lock)
  function checkIfShouldRefreshLabels() {
    if (!IS_SUBSCRIBER) return false;
    
    const now = new Date();
    const utcHour = now.getUTCHours();
    const utcDay = now.getUTCDate();
    const cycle = window.smCustomerCycle || '15';
    
    // Lock momenten (UTC 20:00):
    // - Cycle 15: 6e om 20:00 UTC
    // - Cycle 1: 22e om 20:00 UTC
    const isLockDay = (cycle === '15' && utcDay === 6) || (cycle === '1' && utcDay === 22);
    
    // Window: 20:00 - 22:00 UTC (2 uur na lock)
    const isLockWindow = isLockDay && utcHour >= 20 && utcHour < 22;
    
    if (isLockWindow) {
      calLog('[CACHE] Lock window detected - will refresh labels');
      return true;
    }
    
    // Check timestamp van laatste refresh
    try {
      const lastRefresh = localStorage.getItem(LAST_REFRESH_KEY);
      if (!lastRefresh) return true;
      
      const lastTime = parseInt(lastRefresh, 10);
      const elapsed = Date.now() - lastTime;
      const ONE_DAY = 24 * 60 * 60 * 1000;
      
      // Refresh als laatste refresh >24u geleden was
      if (elapsed > ONE_DAY) {
        calLog('[CACHE] Last refresh >24h ago - will refresh');
        return true;
      }
    } catch(_) {}
    
    return false;
  }

  let labelsPreloaded = false;
  let isLoadingLabels = false;

  // Legacy migratie
  (function migrateLegacyKey(){
    try {
      const legacy = localStorage.getItem('geurkalender');
      if (legacy) {
        localStorage.setItem('geurkalender_guest', legacy);
        localStorage.removeItem('geurkalender');
      }
    } catch(_) {}
  })();

  // Logout cleanup
  (function handleLogoutCleanup(){
    try {
      const prevUid = localStorage.getItem(LAST_UID_KEY);
      if (SERVER_OK && CUSTOMER_ID) {
        localStorage.setItem(LAST_UID_KEY, String(CUSTOMER_ID));
      } else {
        if (prevUid) {
          localStorage.removeItem(GUEST_KEY);
          localStorage.removeItem('geurkalender_guest_updated');
          localStorage.removeItem('geurkalender_guest_updated__ms');
          localStorage.removeItem(LAST_UID_KEY);
        }
      }
    } catch(_){}
  })();

  const readLocal  = (key) => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch(_){ return []; } };
  const writeLocal = (key, months) => { try { localStorage.setItem(key, JSON.stringify(months || [])); } catch(_) {} };

  async function attemptMergeGuestIntoUser(){
    if (!SERVER_OK || !CUSTOMER_ID) return;
    let guestMonths = readLocal(GUEST_KEY);
    const hasGuest = (guestMonths || []).some(Boolean);
    if (!hasGuest) return;

    try {
      const headers = await getCacheHeaders();
      const url = `${API_BASE}/calendar/merge?customer_id=${CUSTOMER_ID}`;

      let r = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ customer_id: CUSTOMER_ID, months: guestMonths })
      });
      
      if (r.status === 401) {
        await new Promise(resolve => setTimeout(resolve, 200));
        r = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ customer_id: CUSTOMER_ID, months: guestMonths })
        });
      }
      
      if (r.status === 401) {
        writeLocal(USER_KEY, guestMonths);
        geurkalender = guestMonths.slice(0,12).map(sanitizeItem);
        localStorage.removeItem(GUEST_KEY);
        localStorage.removeItem('geurkalender_guest_updated');
        localStorage.removeItem('geurkalender_guest_updated__ms');
        setTimeout(() => pushServerNow(), 2000);
        return;
      }
      
      if (!r.ok) return;
      const data = await r.json().catch(()=>null);
      if (!data || !Array.isArray(data.months)) return;

      geurkalender = data.months.slice(0,12).map(sanitizeItem);
      writeLocal(USER_KEY, geurkalender);

      lastServerUpdatedAtISO = data.updatedAt || null;
      lastServerUpdatedAtMS  = tsNum(lastServerUpdatedAtISO);
      writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);

      if (Array.isArray(data.labels)) {
        window.gkServerLabels = data.labels;
        writeCachedLabels(data.labels);
        labelsPreloaded = true;
      }

      localStorage.removeItem(GUEST_KEY);
      localStorage.removeItem('geurkalender_guest_updated');
      localStorage.removeItem('geurkalender_guest_updated__ms');

      renderKalender();
    } catch(_){}
  }

  /* ======================== Body scroll lock ======================== */
  function getScrollbarWidth(){ return window.innerWidth - document.documentElement.clientWidth; }
  function lockBodyScroll() {
    if (document.body.dataset.gkLocked === '1') return;
    const y = window.pageYOffset || document.documentElement.scrollTop || 0;
    const sbw = getScrollbarWidth();
    const prev = getComputedStyle(document.documentElement).scrollBehavior;
    document.documentElement.dataset.gkPrevScrollBehavior = prev || '';
    document.documentElement.style.scrollBehavior = 'auto';
    document.body.dataset.gkLocked = '1';
    document.body.dataset.gkScrollY = String(y);
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${y}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }
  
  function unlockBodyScroll() {
    if (document.body.dataset.gkLocked !== '1') return;
    const y = parseInt(document.body.dataset.gkScrollY || '0', 10) || 0;
    document.body.dataset.gkLocked = '0';
    document.body.removeAttribute('data-gk-scroll-y');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo({ top: y, left: 0, behavior: 'auto' });
    const prev = document.documentElement.dataset.gkPrevScrollBehavior || '';
    if (prev) document.documentElement.style.scrollBehavior = prev; else document.documentElement.style.scrollBehavior = '';
    delete document.documentElement.dataset.gkPrevScrollBehavior;
  }

  /* ======================== Overlay / history ======================== */
  let gkIgnoreDocClickUntil = 0;
  let gkAddDedupUntil = 0;

  // 🔥 REMOVED: Polling elke 12s is niet nodig
  // Focus/visibility events zijn voldoende voor sync
  // let pollTimer = null;
  // function startPolling(){ ... }
  // function stopPolling(){ ... }

  function isModalOpen(){ return !modal.classList.contains('hidden'); }
  
  async function showModalOnly(){
  if (!modal.classList.contains('hidden')) return;
  
  if (!history.state || !history.state.gkOpen) {
    try { history.pushState({ gkOpen: true }, '', location.href); } catch(e) {}
  }
  
  // 🔥 NEW: Version check (non-blocking, instant open!)
  const versionCheckPromise = IS_SUBSCRIBER ? ensureFreshCalendarData() : Promise.resolve(false);
  
  // Voor subscribers: zorg dat labels beschikbaar zijn
  if (IS_SUBSCRIBER && !labelsPreloaded && !isLoadingLabels) {
    const cachedLabels = readCachedLabels();
    if (!cachedLabels) {
      // Background load (non-blocking)
      preloadLabelsForSubscriber().then(() => {
        if (!modal.classList.contains('hidden')) {
          renderKalender();
        }
      }).catch(() => {});
    } else {
      window.gkServerLabels = cachedLabels;
      labelsPreloaded = true;
    }
  }
  
  // Open modal INSTANT (niet wachten!)
  modal.classList.remove('hidden');
  lockBodyScroll();
  gkIgnoreDocClickUntil = Date.now() + 400;
  showDragHintIfNeeded();
  renderKalender();  // Render met huidige data
  
  // Wacht op version check in background
  versionCheckPromise.then(wasUpdated => {
    if (wasUpdated && !modal.classList.contains('hidden')) {
      calLog('[MODAL] Calendar was updated, re-rendering...');
      renderKalender();
    }
  }).catch(e => {
    calError('[MODAL] Version check error:', e);
  });
  
  // 🔥 OPTIMIZED: Eén refresh is genoeg (version check hierboven doet al data fetch indien nodig)
  refreshFromServer();
  // REMOVED: setTimeout(refreshFromServer, 1600) - dubbele call niet nodig
  // REMOVED: startPolling() - focus/visibility events zijn voldoende
}
  
  async function closeModal(){
    if (modal.classList.contains('hidden')) return;

    if (dirty && SERVER_OK && !inflight) {
      const header = modal.querySelector('.geurkalender-header h2');
      const originalText = header ? header.textContent : '';
      
      if (header) {
        header.textContent = 'Opslaan...';
        header.style.opacity = '0.7';
      }
      
      const savePromise = pushServerNow();
      const timeoutPromise = new Promise(resolve => setTimeout(resolve, 800));
      
      try {
        await Promise.race([savePromise, timeoutPromise]);
      } catch(e) {
        calWarn('[Geurkalender] Save error:', e);
      }
      
      if (header) {
        header.textContent = originalText;
        header.style.opacity = '1';
      }
    }
      
    modal.classList.add('hidden');
    // REMOVED: stopPolling() - polling is verwijderd
    unlockBodyScroll();
    if (history.state && history.state.gkOpen) { 
      try { history.back(); } catch(e) {} 
    }
  }
  
  window.addEventListener('popstate', () => { if (isModalOpen()) { modal.classList.add('hidden'); unlockBodyScroll(); } });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isModalOpen()) { e.preventDefault(); closeModal(); } });
  modal.addEventListener('contextmenu', (e) => { if (e.target.closest('.geurkalender-slot')) e.preventDefault(); }, { capture: true });

  /* ======================== UTC FREEZE LOGIC ======================== */
  function nowDate() {
    return window.smNowOverride ? new Date(window.smNowOverride) : new Date();
  }

  function freezeFor(cycle, ship) {
    const shipYear = ship.getFullYear();
    const shipMonth = ship.getMonth();
    
    if (cycle === '15') {
      return new Date(Date.UTC(shipYear, shipMonth, 6, 20, 0, 0));
    } else {
      let freezeYear = shipYear;
      let freezeMonth = shipMonth - 1;
      if (freezeMonth < 0) {
        freezeMonth = 11;
        freezeYear -= 1;
      }
      return new Date(Date.UTC(freezeYear, freezeMonth, 22, 20, 0, 0));
    }
  }

  function nextShipAfter(now, cycle) {
    const y = now.getFullYear(), m = now.getMonth();
    if (cycle === '15') {
      const fifteenth = new Date(y, m, 15);
      return (now <= fifteenth) ? fifteenth : new Date(y, m + 1, 15);
    } else {
      const firstThis = new Date(y, m, 1);
      return (now <= firstThis) ? firstThis : new Date(y, m + 1, 1);
    }
  }

  function firstEditableShipDate(cycle) {
    const now = nowDate();
    let ship = nextShipAfter(now, cycle);
    const fr = freezeFor(cycle, ship);
    if (now >= fr) {
      ship = (cycle === '15')
        ? new Date(ship.getFullYear(), ship.getMonth() + 1, 15)
        : new Date(ship.getFullYear(), ship.getMonth() + 1, 1);
    }
    return ship;
  }

  function resolveCycle() {
    if (window.smCustomerCycle === '1' || window.smCustomerCycle === '15') {
      return window.smCustomerCycle;
    }
    
    const now = nowDate();
    const y = now.getFullYear();
    const m = now.getMonth();
    
    const c15_cutoff = new Date(Date.UTC(y, m, 6, 19, 0, 0));
    const c1_cutoff = new Date(Date.UTC(y, m, 22, 19, 0, 0));
    
    const chosen = (now >= c15_cutoff && now < c1_cutoff) ? '1' : '15';
    
    window.smCustomerCycleResolved = chosen;
    return chosen;
  }

  function getNext12Months() {
    const cycle = resolveCycle();
    const startShip = firstEditableShipDate(cycle);
    const out = [];
    for (let i = 0; i < 12; i++) {
      const ship = (cycle === '15')
        ? new Date(startShip.getFullYear(), startShip.getMonth() + i, 15)
        : new Date(startShip.getFullYear(), startShip.getMonth() + i, 1);
      out.push(
        window.smDebugShowDay
          ? `${cycle === '15' ? '15' : '1'} ${monthNames[ship.getMonth()]} ${ship.getFullYear()}`
          : `${monthNames[ship.getMonth()]} ${ship.getFullYear()}`
      );
    }
    return out;
  }

  /* ======================== Data & helpers ======================== */
  let geurkalender = readLocal(ACTIVE_KEY);
  let lastServerUpdatedAtISO = readUpdatedISO();
  let lastServerUpdatedAtMS  = readUpdatedMS();

  let inflight = false;
  let queued = false;
  let dirty = false;
  let ignoreExternalUntil = 0;

  function normalizeLeftPack() {
    geurkalender = (geurkalender || []).filter(Boolean);
    while (geurkalender.length < 12) geurkalender.push(null);
  }

  function saveKalender(persist = true){
    normalizeLeftPack();
    writeLocal(ACTIVE_KEY, geurkalender);
    if (persist) schedulePersist();
    try { document.dispatchEvent(new CustomEvent('gk:months-changed', { detail: geurkalender })); } catch(_) {}
  }
  
  function firstEmptyIndex(arr){ const i = arr.findIndex(v => !v); return i === -1 ? arr.length : i; }
  
  function sanitizeItem(it){
    if (!it) return null;
    return { title: it.title || 'Product', img: it.img || '', brand: it.brand || '', url: it.url || '#', variantId: it.variantId || undefined };
  }

  // 🎁 Check if variant is blocked (surcharge product for gift customer)
  function isVariantBlocked(variantId) {
    if (!isGiftSubscription || !variantId) return false;
    return blockedVariantIds.has(String(variantId));
  }

  // 🎁 Load gift subscription status and blocked variants
  async function loadGiftBlockStatus() {
    if (!SERVER_OK || !CUSTOMER_ID) return;

    try {
      const headers = await getCacheHeaders();
      const resp = await fetch(
        `${API_BASE}/subscription/status?customer_id=${CUSTOMER_ID}&_=${Date.now()}`,
        { cache: 'no-store', headers: headers }
      );

      if (!resp.ok) return;

      const data = await resp.json();
      if (data.ok && data.data) {
        isGiftSubscription = !!data.data.is_gift;

        // 🔥 Cache to localStorage for instant load on next visit
        if (GIFT_CACHE_KEY) {
          try {
            localStorage.setItem(GIFT_CACHE_KEY, isGiftSubscription ? 'true' : 'false');
          } catch(_) {}
        }

        if (isGiftSubscription && Array.isArray(data.data.blocked_variant_ids)) {
          const variants = data.data.blocked_variant_ids.map(String);
          blockedVariantIds = new Set(variants);

          // Cache blocked variants
          if (BLOCKED_CACHE_KEY) {
            try {
              localStorage.setItem(BLOCKED_CACHE_KEY, JSON.stringify(variants));
            } catch(_) {}
          }

          calLog('[GIFT] Loaded blocked variants:', blockedVariantIds.size);
        } else if (BLOCKED_CACHE_KEY) {
          // Clear cache if not a gift subscription
          try {
            localStorage.removeItem(BLOCKED_CACHE_KEY);
          } catch(_) {}
        }
      }
    } catch (e) {
      calError('[GIFT] Error loading gift status:', e);
    }
  }

  /* ======================== 🔥 Preload labels ======================== */
  async function preloadLabelsForSubscriber() {
    if (!IS_SUBSCRIBER || !SERVER_OK) return;
    
    const cached = readCachedLabels();
    if (cached && !checkIfShouldRefreshLabels()) {
      window.gkServerLabels = cached;
      labelsPreloaded = true;
      return;
    }
    
    try {
      const url = API_BASE + '/calendar?customer_id=' + encodeURIComponent(CUSTOMER_ID) + '&_=' + Date.now();
      const headers = await getCacheHeaders();
      const response = await fetch(url, {
        cache: 'no-store',
        headers: headers
      });
      
      if (response.ok) {
        const data = await response.json();
        
        if (Array.isArray(data.labels) && data.labels.length > 0) {
          window.gkServerLabels = data.labels;
          writeCachedLabels(data.labels);
          labelsPreloaded = true;
          
          // Update last refresh timestamp
          try {
            localStorage.setItem(LAST_REFRESH_KEY, String(Date.now()));
          } catch(_) {}
        }
        
        if (Array.isArray(data.months)) {
          const server = data.months.slice(0, 12).map(sanitizeItem);
          const serverISO = data.updatedAt || null;
          const serverTS  = tsNum(serverISO);
          
          if (serverTS > lastServerUpdatedAtMS) {
            geurkalender = server;
            lastServerUpdatedAtISO = serverISO;
            lastServerUpdatedAtMS = serverTS;
            writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
            saveKalender(false);
          }
        }
      }
    } catch(e) {
      calError('[Geurkalender] Labels preload error:', e);
    }
  }

  /* ======== SERVER I/O ======== */
  let persistTimer = null;
  function schedulePersist() {
    if (!SERVER_OK) return;
    clearTimeout(persistTimer);
    persistTimer = setTimeout(pushServerNow, 50);
  }

  async function doSaveSnapshot(snapshot, clientIso) {
    const payload = { customer_id: CUSTOMER_ID, months: snapshot, clientUpdatedAt: clientIso || null };
    const headers = await getAuthHeaders();
    const r = await fetch(API_BASE + '/calendar/save', {
      method: 'POST',
      headers: headers,
      keepalive: true,
      body: JSON.stringify(payload)
    });
    if (r.status === 409) {
      const data = await r.json().catch(()=>null);
      const srvISO = data && data.updatedAt || null;
      if (srvISO) {
        lastServerUpdatedAtISO = srvISO;
        lastServerUpdatedAtMS  = tsNum(srvISO);
        writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
      }
      return { ok:false, conflict:true };
    }
    if (r.ok) {
      const data = await r.json().catch(()=>null);
      const srvISO = data && data.updatedAt || null;
      if (srvISO) {
        lastServerUpdatedAtISO = srvISO;
        lastServerUpdatedAtMS  = tsNum(srvISO);
        writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
      }
      return { ok:true };
    }
    return { ok:false, conflict:false };
  }

  async function pushServerNow(){
  if (!SERVER_OK) return false;

  if (inflight) { queued = true; return false; }
  inflight = true;

  const snapshot = (geurkalender || []).slice(0,12).map(sanitizeItem);
  
  // 🔥 NEW: Get current version
  const currentVersion = parseInt(localStorage.getItem(`gk_version_${CUSTOMER_ID}`) || '0');

  let result = { ok:false, conflict:false };
  try {
    const headers = await getAuthHeaders();
    const response = await fetch(API_BASE + '/calendar/save', {
      method: 'POST',
      headers: headers,
      keepalive: true,
      body: JSON.stringify({
        customer_id: CUSTOMER_ID,
        months: snapshot,
        clientUpdatedAt: lastServerUpdatedAtISO || null,
        version: currentVersion  // 🔥 NEW
      })
    });
    
    // 🔥 Handle 401 (JWT invalid)
    if (response.status === 401) {
      clearJwtCache();
      calError('[SAVE] 401 Unauthorized - JWT cache cleared');
    }

    // 🔥 Handle stale data conflict (409)
    // clientUpdatedAt is ouder dan de laatste lock. Haal ALLEEN de verse
    // timestamp op, behoud lokale kalenderdata, en retry de save.
    if (response.status === 409) {
      calLog('[SAVE] 409 Conflict - fetching fresh timestamp, keeping local data...');
      inflight = false;

      // Haal verse timestamp op zonder lokale data te overschrijven
      try {
        const tsUrl = `${API_BASE}/calendar?customer_id=${encodeURIComponent(CUSTOMER_ID)}&_=${Date.now()}`;
        const tsHeaders = await getCacheHeaders();
        const tsResp = await fetch(tsUrl, { cache: 'no-store', headers: tsHeaders });
        if (tsResp.ok) {
          const tsData = await tsResp.json();
          if (tsData.updatedAt) {
            lastServerUpdatedAtISO = tsData.updatedAt;
            lastServerUpdatedAtMS = tsNum(tsData.updatedAt);
            writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
          }
          if (tsData.version) {
            localStorage.setItem(`gk_version_${CUSTOMER_ID}`, String(tsData.version));
          }
        }
      } catch(e) {
        calError('[SAVE] Failed to fetch fresh timestamp:', e);
      }

      // Retry save 1x met verse timestamp
      if (!pushServerNow._409retried) {
        pushServerNow._409retried = true;
        calLog('[SAVE] Retrying save with fresh timestamp...');
        dirty = true;
        queued = false;
        setTimeout(pushServerNow, 200);
      } else {
        calLog('[SAVE] 409 retry already attempted, saving locally only');
        pushServerNow._409retried = false;
        dirty = false;
      }
      return false;
    } else if (response.ok) {
    const data = await response.json().catch(() => null);
    const srvISO = data && data.updatedAt || null;
    
    // 🔥 FIX: Update version after successful save
    if (data && data.version) {
        localStorage.setItem(`gk_version_${CUSTOMER_ID}`, String(data.version));
        calLog('[SAVE] Version updated to:', data.version);
    }
    
    if (srvISO) {
        lastServerUpdatedAtISO = srvISO;
        lastServerUpdatedAtMS = tsNum(srvISO);
        writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
    }
    result = { ok: true };
}
  } catch(e) {
    calError('[SAVE] Error:', e);
  }

  inflight = false;
  if (result.ok) {
    dirty = false;
  }
  if (queued) { queued = false; setTimeout(pushServerNow, 0); }

    if (!result.ok) {
      try {
        const raw = JSON.stringify({ customer_id: CUSTOMER_ID, months: snapshot, clientUpdatedAt: lastServerUpdatedAtISO || null });
        if (navigator.sendBeacon) {
          const blob = new Blob([raw], { type: 'text/plain;charset=UTF-8' });
          navigator.sendBeacon(API_BASE + '/calendar/save', blob);
        } else {
          fetch(API_BASE + '/calendar/save', { method:'POST', mode:'no-cors', keepalive:true, headers:{'Content-Type':'text/plain;charset=UTF-8'}, body: raw });
        }
      } catch(_){}
    }
    return result.ok;
  }

  // 🔥 Inflight guard voor refreshFromServer
  let refreshInflight = false;

  async function refreshFromServer() {
    if (!SERVER_OK) return;
    if (Date.now() < ignoreExternalUntil) return;
    if (inflight || dirty) return;

    // 🔥 Prevent parallel refresh calls
    if (refreshInflight) {
      calLog('[CALENDAR] Refresh already in progress, skipping...');
      return;
    }
    refreshInflight = true;

    try {
        const url = `${API_BASE}/calendar?customer_id=${encodeURIComponent(CUSTOMER_ID)}&_=${Date.now()}`;

        calLog(`[CALENDAR] Refreshing from server (subscriber=${IS_SUBSCRIBER})...`);

        const headers = await getCacheHeaders();
        const response = await fetch(url, {
            cache: 'no-store',
            headers: headers
        });
        
        if (!response.ok) {
            // 🔥 401 = JWT invalid, clear cache voor volgende poging
            if (response.status === 401) {
                clearJwtCache();
            }
            calError('[CALENDAR] Server refresh failed:', response.status);
            return;
        }
        
        const data = await response.json();
        
        if (!data || !Array.isArray(data.months)) {
            calError('[CALENDAR] Invalid response:', data);
            return;
        }
        
        calLog(`[CALENDAR] Data loaded from: ${data.source || 'unknown'}`);
        
        // 🔥 NEW: Check if labels changed
        const labelsChanged = !window.gkServerLabels || 
                              JSON.stringify(window.gkServerLabels) !== JSON.stringify(data.labels);
        
        if (Array.isArray(data.labels) && data.labels.length > 0) {
            window.gkServerLabels = data.labels;
            writeCachedLabels(data.labels);
            labelsPreloaded = true;
            
            calLog('[CALENDAR] Labels updated:', data.labels.slice(0, 3));
            
            try {
                localStorage.setItem(LAST_REFRESH_KEY, String(Date.now()));
            } catch(_) {}
        }
        
        const server = data.months.slice(0, 12).map(sanitizeItem);
        const serverISO = data.updatedAt || null;
        const serverTS  = tsNum(serverISO);

        // 🔥 UPDATED: Force update if labels changed OR timestamp newer
        if (serverTS > lastServerUpdatedAtMS || labelsChanged) {
    calLog('[CALENDAR] Updating local state from server', {
        timestampChanged: serverTS > lastServerUpdatedAtMS,
        labelsChanged: labelsChanged
    });
    
    geurkalender = server;
    lastServerUpdatedAtISO = serverISO; 
    lastServerUpdatedAtMS = serverTS; 
    writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
    
    // 🔥 FIX: Update version from server
    if (data.version) {
        localStorage.setItem(`gk_version_${CUSTOMER_ID}`, String(data.version));
        calLog('[REFRESH] Version updated to:', data.version);
    }
    
    saveKalender(false); 
    renderKalender();
} else if (serverTS > 0 && serverTS < lastServerUpdatedAtMS) {
            calLog('[CALENDAR] Local newer than server, pushing update');
            await pushServerNow();
        }
    } catch(e) {
        calError('[CALENDAR] Refresh error:', e);
    } finally {
        // 🔥 Always reset inflight guard
        refreshInflight = false;
    }
}

  async function saveToServer(payload) {
    try {
        const res = await fetch('/calendar/save', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        
        if (res.status === 409) {
            const data = await res.json();
            if (data.error === 'stale_data') {
                calLog('[CALENDAR] Stale data detected - refreshing...');
                
                // 🔥 Auto-refresh from server
                await refreshFromServer();
                
                // Optional: Show user-friendly message
                // alert('Je kalender is bijgewerkt. De nieuwste versie wordt getoond.');
                
                return;
            }
        }
        
        // ... rest van save logic
    } catch (e) {
        calError('[CALENDAR SAVE] Error:', e);
    }
  }
  // Fallback to Shopify if PostgreSQL fails
  async function refreshFromShopify() {
    try {
        const url = `${API_BASE}/calendar?customer_id=${encodeURIComponent(CUSTOMER_ID)}&_=${Date.now()}`;
        const headers = await getCacheHeaders();
        const response = await fetch(url, { cache: 'no-store', headers: headers });
        
        if (!response.ok) return;
        
        const data = await response.json();
        
        if (data && Array.isArray(data.months)) {
            calLog('[CALENDAR] Fallback to Shopify successful');
            
            const server = data.months.slice(0, 12).map(sanitizeItem);
            const serverISO = data.updatedAt || null;
            const serverTS  = tsNum(serverISO);
            
            if (serverTS > lastServerUpdatedAtMS) {
                geurkalender = server;
                lastServerUpdatedAtISO = serverISO; 
                lastServerUpdatedAtMS = serverTS; 
                writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
                
                saveKalender(false); 
                renderKalender();
            }
        }
    } catch(e) {
        calError('[CALENDAR] Shopify fallback failed:', e);
    }
  } 


  /* ======================== RENDER ======================== */
  function renderKalender() {
    const grid = document.querySelector('.geurkalender-grid');
    if (!grid) return;

    normalizeLeftPack();
    grid.innerHTML = '';

    // 🔥 CRITICAL FIX: Gebruik server labels ALLEEN voor subscribers
    const monthLabels = (IS_SUBSCRIBER && window.gkServerLabels) 
      ? window.gkServerLabels 
      : getNext12Months();

    calLog('[Geurkalender] Render:', {
      IS_SUBSCRIBER,
      hasServerLabels: !!window.gkServerLabels,
      usingServerLabels: IS_SUBSCRIBER && !!window.gkServerLabels,
      firstLabel: monthLabels[0]
    });

    for (let i = 0; i < 12; i++) {
      const slot = document.createElement('div');
      slot.className = 'geurkalender-slot';
      slot.dataset.index = String(i);
      const monthLabel = `<span class="slot-month">${monthLabels[i]}</span>`;

      if (geurkalender[i]) {
        slot.classList.add('filled');
        const p = geurkalender[i];
        const safeTitle = (p.title || '').replace(/"/g, '&quot;');
        // Add variant-id for surcharge badge support
        if (p.variantId) {
          slot.setAttribute('data-variant-id', p.variantId);
        }
        slot.innerHTML = `
          ${monthLabel}
          <button class="slot-remove" data-index="${i}" title="Verwijder">−</button>
          <a href="${p.url}" class="slot-product-link" draggable="false">
            <div class="slot-product" draggable="false">
              <img src="${p.img}" alt="${safeTitle}" draggable="false">
              <span class="slot-title">${safeTitle}</span>
              <span class="slot-brand">${p.brand || ''}</span>
            </div>
          </a>`;
      } else {
        slot.innerHTML = `
          ${monthLabel}
          <div class="slot-inner slot-go-products" title="Kies een parfum">+</div>`;
      }
      grid.appendChild(slot);
    }
    enableDragAndDrop();

    // Apply surcharge badges to geurkalender slots
    if (window.SmellishSurcharges && typeof window.SmellishSurcharges.load === 'function') {
      window.SmellishSurcharges.load().then(surcharges => {
        if (surcharges && Object.keys(surcharges).length > 0) {
          window.SmellishSurcharges.apply(surcharges);
        }
      });
    }

    // "Nieuw" badges bewust NIET in geurkalender - te rommelig in kleine slots
    // Surcharge badge is voldoende; "nieuw" info is irrelevant voor gekozen geuren
  }

  function addToKalender(title,img,brand,url,variantId){
    // 🎁 Block surcharge products for gift subscriptions
    if (isVariantBlocked(variantId)) {
      showBlockedProductMessage(title);
      return false;
    }

    dirty = true;
    normalizeLeftPack();
    for (let i=0;i<12;i++){
      if (!geurkalender[i]) {
        geurkalender[i] = sanitizeItem({title,img,brand,url,variantId});
        break;
      }
    }
    ignoreExternalUntil = Date.now() + 1200;
    saveKalender(true);

    if (SERVER_OK && !inflight) {
      clearTimeout(persistTimer);
      pushServerNow();
    }

    renderKalender();
    return true;
  }

  // 🎁 Show message when blocked product is attempted
  function showBlockedProductMessage(productTitle) {
    // Remove any existing message
    const existing = document.querySelector('.gk-blocked-message');
    if (existing) existing.remove();

    const msg = document.createElement('div');
    msg.className = 'gk-blocked-message';
    msg.innerHTML = `
      <div class="gk-blocked-content">
        <span class="gk-blocked-icon">🎁</span>
        <p><strong>${productTitle || 'Dit parfum'}</strong> is een premium geur met toeslag.</p>
        <p>Deze is niet beschikbaar bij je cadeau-abonnement. Kies een andere geur!</p>
        <button class="gk-blocked-close">Begrepen</button>
      </div>
    `;

    // Style the message
    msg.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 100001;
      animation: fadeIn 0.2s ease;
    `;

    const content = msg.querySelector('.gk-blocked-content');
    content.style.cssText = `
      background: #fff;
      padding: 24px 32px;
      border-radius: 12px;
      text-align: center;
      max-width: 320px;
      box-shadow: 0 8px 32px rgba(0,0,0,0.3);
    `;

    const icon = msg.querySelector('.gk-blocked-icon');
    icon.style.cssText = `
      font-size: 40px;
      display: block;
      margin-bottom: 12px;
    `;

    const btn = msg.querySelector('.gk-blocked-close');
    btn.style.cssText = `
      background: #000;
      color: #fff;
      border: none;
      padding: 10px 24px;
      border-radius: 6px;
      cursor: pointer;
      margin-top: 16px;
      font-weight: 600;
    `;

    btn.addEventListener('click', () => msg.remove());
    msg.addEventListener('click', (e) => {
      if (e.target === msg) msg.remove();
    });

    document.body.appendChild(msg);
  }
  
  function removeFromKalender(index){
    dirty = true;
    geurkalender.splice(index,1);
    while (geurkalender.length<12) geurkalender.push(null);
    ignoreExternalUntil = Date.now() + 1200;
    saveKalender(true);

    if (SERVER_OK && !inflight) {
      clearTimeout(persistTimer);
      pushServerNow();
    }

    renderKalender();
  }

  async function autoFillKalender() {
    const emptyCount = geurkalender.filter(s => !s).length;
    if (emptyCount === 0) return;

    const btn = document.getElementById('gk-autofill-btn');
    const resetBtn = (label) => {
      if (!btn) return;
      btn.disabled = false;
      btn.textContent = label || 'Auto-vullen';
    };

    if (btn) { btn.disabled = true; btn.textContent = 'Bezig...'; }

    try {
      const gender = window.smellishGender || null;
      // Collect variant IDs already in the calendar to prevent duplicates
      const existingVariantIds = geurkalender
        .filter(Boolean)
        .map(p => p.variantId)
        .filter(Boolean);

      // Compute month numbers (1-12) for each empty slot for per-slot season matching
      const monthLabelsForFill = (IS_SUBSCRIBER && window.gkServerLabels)
        ? window.gkServerLabels
        : getNext12Months();
      const monthAbbrevToNum = {jan:1,feb:2,mrt:3,apr:4,mei:5,jun:6,jul:7,aug:8,sep:9,okt:10,nov:11,dec:12};
      const emptySlotMonths = [];
      for (let i = 0; i < 12; i++) {
        if (!geurkalender[i] && monthLabelsForFill[i]) {
          const parts = monthLabelsForFill[i].split(' ');
          // Label is "mrt 2026" or "15 mrt 2026"
          const monthStr = parts.length === 3 ? parts[1] : parts[0];
          const monthNum = monthAbbrevToNum[monthStr.toLowerCase()] || null;
          if (monthNum) emptySlotMonths.push(monthNum);
        }
      }

      let url = `${API_BASE}/calendar/auto-fill?needed=${emptyCount}`;
      if (CUSTOMER_ID) url += `&customer_id=${CUSTOMER_ID}`;
      if (gender) url += `&gender=${encodeURIComponent(gender)}`;
      if (existingVariantIds.length > 0) url += `&exclude=${existingVariantIds.join(',')}`;
      if (emptySlotMonths.length > 0) url += `&slot_months=${emptySlotMonths.join(',')}`;

      const headers = await getAuthHeaders();
      const res = await fetch(url, { headers });
      if (!res.ok) throw new Error(`auto-fill request failed: ${res.status}`);
      const data = await res.json();

      const productQueue = (data.products || []).slice();

      // No products returned (e.g. empty stock) → show brief message, do nothing
      if (productQueue.length === 0) {
        resetBtn('Geen geuren beschikbaar');
        setTimeout(() => resetBtn('Auto-vullen'), 2500);
        return;
      }

      for (let i = 0; i < 12; i++) {
        if (!geurkalender[i] && productQueue.length > 0) {
          geurkalender[i] = sanitizeItem(productQueue.shift());
        }
      }

      dirty = true;
      ignoreExternalUntil = Date.now() + 1200;
      saveKalender(true);
      if (SERVER_OK && !inflight) {
        clearTimeout(persistTimer);
        pushServerNow();
      }
      renderKalender();
      resetBtn('Auto-vullen');
    } catch (err) {
      calError('[AUTO-FILL] Error:', err);
      resetBtn('Probeer opnieuw');
      setTimeout(() => resetBtn('Auto-vullen'), 2500);
    }
  }

  function clearAllKalender() {
    const filled = geurkalender.filter(Boolean).length;
    if (filled === 0) return;
    if (!confirm(`Weet je zeker dat je alle ${filled} geuren wilt verwijderen?`)) return;

    geurkalender = Array(12).fill(null);
    dirty = true;
    ignoreExternalUntil = Date.now() + 1200;
    saveKalender(true);
    if (SERVER_OK && !inflight) {
      clearTimeout(persistTimer);
      pushServerNow();
    }
    renderKalender();
  }
  
  function openModalWithProduct(title,img,brand,url,variantId){
  addToKalender(title,img,brand,url,variantId);
  
  // 🆕 SIMPLIFIED - Track calendar add (check happens inside function)
  trackCalendarAdd(title, variantId);
  
  showModalOnly();
}

// 🆕 NEW FUNCTION - Add after openModalWithProduct
// 🆕 IMPROVED VERSION
async function trackCalendarAdd(productTitle, variantId) {
  try {
    // Check if from quiz (with 30 min expiry)
    const quizActive = localStorage.getItem('quiz_active');
    const quizTimestamp = localStorage.getItem('quiz_timestamp');
    
    if (!quizActive || quizActive !== 'true') {
      calLog('[CALENDAR] Not from quiz - skipping tracking');
      return;
    }
    
    // Check expiry (30 minutes)
    if (quizTimestamp) {
      const age = Date.now() - parseInt(quizTimestamp);
      const MAX_AGE = 30 * 60 * 1000; // 30 min
      
      if (age > MAX_AGE) {
        calLog('[CALENDAR] Quiz session expired - skipping tracking');
        localStorage.removeItem('quiz_active');
        localStorage.removeItem('quiz_timestamp');
        return;
      }
    }
    
    const sessionId = localStorage.getItem('quiz_session_id');
    
    if (!sessionId) {
      calWarn('[CALENDAR] No quiz session ID found!');
      return;
    }
    
    calLog('[CALENDAR] 🎯 Tracking quiz calendar add:', {
      productTitle,
      sessionId,
      customerId: CUSTOMER_ID
    });
    
    const response = await fetch(`${API_BASE}/quiz/track-calendar-add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        session_id: sessionId,
        customer_id: CUSTOMER_ID,
        product_title: productTitle,
        product_variant_id: variantId
      })
    });
    
    const result = await response.json();
    calLog('[CALENDAR] Tracking result:', result);
    
    // Clear flag after successful track
    if (result.ok) {
      localStorage.removeItem('quiz_active');
      localStorage.removeItem('quiz_timestamp');
    }
    
  } catch (error) {
    calError('[CALENDAR] Tracking failed:', error);
  }
}

// Helper: Get quiz session ID from localStorage
function getQuizSessionId() {
  try {
    return localStorage.getItem('quiz_session_id');
  } catch(_) {
    return null;
  }
}

  /* ==================== DRAG & DROP (UNCHANGED) ==================== */
  let suppressClickUntil = 0;

  function enableDragAndDrop() {
    const grid = document.querySelector('.geurkalender-grid');
    if (!grid) return;

    grid.querySelectorAll('.geurkalender-slot').forEach(s => s.classList.remove('drag-over','dragging'));
    grid.querySelectorAll('.geurkalender-slot.filled a, .geurkalender-slot.filled img, .geurkalender-slot.filled .slot-product')
      .forEach(el => el.setAttribute('draggable','false'));

    const ANIM_MS = 420;
    const EASING  = 'cubic-bezier(0.2, 0.8, 0.2, 1)';

    function getSlotUnder(x, y) { const el = document.elementFromPoint(x, y); return el && el.closest('.geurkalender-slot'); }
    function swap(fromIndex, toIndex) { const t = geurkalender[fromIndex]; geurkalender[fromIndex] = geurkalender[toIndex]; geurkalender[toIndex] = t; }
    
    function FLIPAnimateSwap(fromIndex, toIndex, onDone){
      const fromEl = grid.querySelector(`.geurkalender-slot[data-index="${fromIndex}"]`);
      const toEl   = grid.querySelector(`.geurkalender-slot[data-index="${toIndex}"]`);
      if (!fromEl || !toEl) { onDone?.(); return; }
      const fromRect = fromEl.getBoundingClientRect();
      const toRect   = toEl.getBoundingClientRect();
      const dx = toRect.left - fromRect.left;
      const dy = toRect.top  - fromRect.top;
      fromEl.style.willChange = 'transform, opacity';
      toEl.style.willChange   = 'transform, opacity';
      fromEl.style.transition = toEl.style.transition = `transform ${ANIM_MS}ms ${EASING}, opacity ${ANIM_MS}ms ${EASING}`;
      fromEl.offsetHeight;
      fromEl.style.transform = `translate(${dx}px, ${dy}px)`;
      toEl.style.transform   = `translate(${-dx}px, ${-dy}px)`;
      fromEl.style.opacity = '0.94'; toEl.style.opacity = '0.94';
      setTimeout(() => {
        fromEl.style.transition = toEl.style.transition = '';
        fromEl.style.transform = toEl.style.transform = '';
        fromEl.style.opacity = toEl.style.opacity = '';
        fromEl.style.willChange = toEl.style.willChange = '';
        onDone?.();
      }, ANIM_MS + 12);
    }

    let isDragging = false, animating = false, dropPending = false;
    let dragEl = null, fromIndex = null, currentOver = null, ghost = null;
    let startX = 0, startY = 0, hasMoved = false, pressTimer = null;

    function createGhost(fromSlot, x, y){
      const rect = fromSlot.getBoundingClientRect();
      const g = fromSlot.cloneNode(true);
      g.classList.add('gk-touch-ghost');
      g.style.position = 'fixed';
      g.style.left = (x - rect.width/2) + 'px';
      g.style.top  = (y - rect.height/2) + 'px';
      g.style.width = rect.width + 'px';
      g.style.height = rect.height + 'px';
      g.style.pointerEvents = 'none';
      g.style.zIndex = '100000';
      g.style.opacity = '0.98';
      g.style.transform = 'scale(0.985)';
      g.style.boxShadow = '0 12px 24px rgba(0,0,0,0.25)';
      document.body.appendChild(g);
      return g;
    }
    
    function moveGhost(g, x, y){
      const r = g.getBoundingClientRect();
      g.style.left = (x - r.width/2) + 'px';
      g.style.top  = (y - r.height/2) + 'px';
    }
    
    function cleanup() {
      if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
      ghost = null;
      if (dragEl) {
        dragEl.classList.remove('dragging');
        dragEl.querySelectorAll('a, img, .slot-remove').forEach(el => el.style.pointerEvents = '');
      }
      if (currentOver) currentOver.classList.remove('drag-over');
      isDragging = false; hasMoved = false; animating = false; dropPending = false;
      dragEl = null; currentOver = null; fromIndex = null;
      document.removeEventListener('mousemove', preDragMove);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    }

    let pendingTarget = null;
    function requestAutoSwap(toIdx){
      const limit = firstEmptyIndex(geurkalender);
      const clamped = Math.min(toIdx, limit);
      if (clamped === fromIndex) return;

      suppressClickUntil = Date.now() + 500;

      if (animating) { pendingTarget = clamped; return; }
      animating = true;

      FLIPAnimateSwap(fromIndex, clamped, () => {
        dirty = true;
        swap(fromIndex, clamped);
        ignoreExternalUntil = Date.now() + 1200;
        saveKalender(true);
        
        if (SERVER_OK && !inflight) {
          clearTimeout(persistTimer);
          pushServerNow();
        }
        
        renderKalender();

        const newGrid = document.querySelector('.geurkalender-grid');
        const newDragEl = newGrid && newGrid.querySelector(`.geurkalender-slot.filled[data-index="${clamped}"]`);
        if (newDragEl && !dropPending) {
          dragEl = newDragEl; fromIndex = clamped; isDragging = true;
          dragEl.querySelectorAll('a, img, .slot-remove').forEach(el => el.style.pointerEvents = 'none');
        }

        const next = pendingTarget; pendingTarget = null; animating = false;
        if (next != null && !dropPending) setTimeout(() => requestAutoSwap(next), 0);
        if (dropPending) setTimeout(cleanup, 0);
      });
    }

    const THRESH = 2;
    function preDragMove(e){
      const dx = Math.abs(e.clientX - startX);
      const dy = Math.abs(e.clientY - startY);
      if (dx > THRESH || dy > THRESH) {
        isDragging = true;
        dragEl.classList.add('dragging');
        dragEl.querySelectorAll('a, img, .slot-remove').forEach(el => el.style.pointerEvents = 'none');
        ghost = createGhost(dragEl, startX, startY);
        document.removeEventListener('mousemove', preDragMove);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      }
    }
    
    function onMouseMove(e){
      if (!isDragging) return;
      hasMoved = true;
      moveGhost(ghost, e.clientX, e.clientY);
      const over = getSlotUnder(e.clientX, e.clientY);
      if (over && over.parentElement === grid) {
        if (currentOver && currentOver !== over) currentOver.classList.remove('drag-over');
        currentOver = over; currentOver.classList.add('drag-over');
        const toIdx = parseInt(over.dataset.index, 10);
        if (!Number.isNaN(toIdx)) requestAutoSwap(toIdx);
      } else {
        if (currentOver) { currentOver.classList.remove('drag-over'); currentOver = null; }
      }
      e.preventDefault();
    }
    
    function onMouseUp(){
      if (isDragging) suppressClickUntil = Date.now() + 450;
      if (animating) { dropPending = true; } else { cleanup(); }
    }

    grid.querySelectorAll('.geurkalender-slot.filled').forEach(slot => {
      slot.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        if (e.target.closest('.slot-remove')) return;
        dragEl = slot; fromIndex = parseInt(slot.dataset.index, 10);
        startX = e.clientX; startY = e.clientY; hasMoved = false;
        document.addEventListener('mousemove', preDragMove);
        document.addEventListener('mouseup', onMouseUp);
      });
    });

    grid.querySelectorAll('.geurkalender-slot.filled').forEach(slot => {
      slot.addEventListener('touchstart', function(e){
        if (e.target.closest('.slot-remove')) return;
        const t = e.touches[0]; startX = t.clientX; startY = t.clientY;
        pressTimer = setTimeout(() => {
          dragEl = slot; fromIndex = parseInt(slot.dataset.index, 10);
          isDragging = true; dragEl.classList.add('dragging');
          dragEl.querySelectorAll('a, img, .slot-remove').forEach(el => el.style.pointerEvents = 'none');
          ghost = createGhost(slot, startX, startY);
          if (navigator.vibrate) { try { navigator.vibrate(50); } catch(_){} }
        }, 500);
      }, { passive: true });

      slot.addEventListener('touchmove', function(e){
        const t = e.touches[0];
        const dx = Math.abs(t.clientX - startX);
        const dy = Math.abs(t.clientY - startY);
        if (!isDragging && (dx > 8 || dy > 8)) { clearTimeout(pressTimer); return; }
        if (!isDragging) return;
        hasMoved = true; moveGhost(ghost, t.clientX, t.clientY);
        const over = getSlotUnder(t.clientX, t.clientY);
        if (over && over.parentElement === grid) {
          if (currentOver && currentOver !== over) currentOver.classList.remove('drag-over');
          currentOver = over; currentOver.classList.add('drag-over');
          const toIdx = parseInt(over.dataset.index, 10);
          if (!Number.isNaN(toIdx)) requestAutoSwap(toIdx);
        } else {
          if (currentOver) { currentOver.classList.remove('drag-over'); currentOver = null; }
        }
        e.preventDefault();
      }, { passive: false });

      slot.addEventListener('touchend', function(){
        clearTimeout(pressTimer);
        if (isDragging) suppressClickUntil = Date.now() + 500;
        if (animating) { dropPending = true; } else { cleanup(); }
      }, { passive: true });

      slot.addEventListener('touchcancel', function(){
        clearTimeout(pressTimer); dropPending = false; cleanup();
      }, { passive: true });
    });
  }

  document.addEventListener('click', function(ev){
    if (Date.now() < suppressClickUntil) {
      if (ev.target.closest('.geurkalender-slot')) { ev.preventDefault(); ev.stopPropagation(); }
    }
  }, true);

  /* ======================== EVENT LISTENERS ======================== */
  closeBtn && closeBtn.addEventListener('click', (e)=>{ e.preventDefault(); closeModal(); });

  document.addEventListener('click', function (e) {
    if (!isModalOpen()) return;
    if (Date.now() < gkIgnoreDocClickUntil) return;
    const clickInsideModal = modal.contains(e.target);
    const clickOnPlusBtn   = e.target.closest('.fav-add-to-calendar, .add-to-calendar');
    const clickOnRemoveBtn = e.target.closest('.slot-remove');
    const clickOnCloseBtn  = e.target.closest('#close-geurkalender');
    if (!clickInsideModal && !clickOnPlusBtn && !clickOnRemoveBtn && !clickOnCloseBtn) closeModal();
  });

  document.body.addEventListener('click', e => {
    const btn = e.target.closest('.fav-add-to-calendar');
    if (btn) {
      if (Date.now() < gkAddDedupUntil) { e.preventDefault(); e.stopPropagation(); return; }
      gkAddDedupUntil = Date.now() + 1200; // ✅ Langer voor animatie
      e.preventDefault(); e.stopPropagation();

      // ✅ Animatie: spin + pulse
      btn.classList.add('adding');

      setTimeout(() => {
        // ✅ Na spin: toon vinkje
        btn.classList.remove('adding');
        btn.classList.add('added');

        setTimeout(() => {
          // ✅ Open geurkalender
          openModalWithProduct(btn.dataset.title, btn.dataset.img, btn.dataset.brand || '', btn.dataset.url || '#', btn.dataset.variantId || undefined);

          // ✅ Reset button na 1.5 seconde
          setTimeout(() => {
            btn.classList.remove('added');
          }, 1500);
        }, 300);
      }, 500);
    }
  });

  document.body.addEventListener('click', e => {
    const removeBtn = e.target.closest('.slot-remove');
    if (removeBtn) {
      e.preventDefault();
      const slot = removeBtn.closest('.geurkalender-slot');
      const index = parseInt(removeBtn.dataset.index, 10);

      // ✅ Animatie: slot krimpt en fade out
      if (slot) {
        slot.classList.add('removing');
        setTimeout(() => {
          removeFromKalender(index);
        }, 300);
      } else {
        removeFromKalender(index);
      }
      return;
    }
    const goBtn = e.target.closest('.slot-go-products');
    if (goBtn) window.location.href = 'https://smellish.nl/collections/products?';
    if (e.target.closest('#gk-autofill-btn')) { e.preventDefault(); autoFillKalender(); }
    if (e.target.closest('#gk-clearall-btn')) { e.preventDefault(); clearAllKalender(); }
    const infoIcon = e.target.closest('#gk-info-icon');
    if (infoIcon) {
      e.preventDefault();
      const wrap = infoIcon.closest('.gk-info-wrap');
      if (wrap) {
        const isOpen = wrap.classList.contains('tooltip-open');
        // Close any other open tooltips
        document.querySelectorAll('.gk-info-wrap.tooltip-open').forEach(w => w.classList.remove('tooltip-open'));
        if (!isOpen) wrap.classList.add('tooltip-open');
      }
      return;
    }
    // Close tooltip on click outside
    if (!e.target.closest('.gk-info-wrap')) {
      document.querySelectorAll('.gk-info-wrap.tooltip-open').forEach(w => w.classList.remove('tooltip-open'));
    }
  });

  document.body.addEventListener('click', e => {
    const btn = e.target.closest('.geurkalender-knop');
    if (btn) {
      if (Date.now() < gkAddDedupUntil) { e.preventDefault(); e.stopPropagation(); return; }
      gkAddDedupUntil = Date.now() + 1200;
      e.preventDefault(); e.stopPropagation();

      btn.classList.add('adding');

      setTimeout(() => {
        btn.classList.remove('adding');
        btn.classList.add('added');

        setTimeout(() => {
          openModalWithProduct(btn.dataset.title, btn.dataset.img, btn.dataset.brand || '', btn.dataset.url || '#', btn.dataset.variantId || undefined);

          setTimeout(() => {
            btn.classList.remove('added');
          }, 1500);
        }, 300);
      }, 500);
    }
  });

  document.addEventListener('click', function(e){
    const openIcon = e.target.closest('.open-geurkalender-icon');
    if (openIcon) { e.preventDefault(); showModalOnly(); }
  });

  function handleAccountOpen(evt){
    const link = evt.target.closest('.open-geurkalender-account');
    if (!link) return;
    evt.preventDefault(); evt.stopPropagation();
    if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
    showModalOnly();
  }
  document.addEventListener('click', handleAccountOpen, true);
  document.addEventListener('keydown', function(e){
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('.open-geurkalender-account')) { e.preventDefault(); handleAccountOpen(e); }
  }, true);

  (function(){
    function scrapeRecoCardData(btn){
      const card = btn.closest('.product-card');
      const linkEl = card && card.querySelector('a[href]');
      const imgEl  = card && card.querySelector('.product-image img');
      const titleEl= card && card.querySelector('.product-title');
      const brandEl= card && card.querySelector('.product-vendor');
      const title = (btn.dataset.title) || (titleEl && titleEl.textContent.trim()) || (imgEl && imgEl.alt && imgEl.alt.trim()) || 'Product';
      const img   = (btn.dataset.img)   || (imgEl && (imgEl.currentSrc || imgEl.src)) || '';
      const brand = (btn.dataset.brand) || (brandEl && brandEl.textContent.trim()) || '';
      const url   = (btn.dataset.url)   || (linkEl && linkEl.href) || '#';
      const variantId = btn.dataset.variantId || undefined;
      return { title, img, brand, url, variantId };
    }
    function handleRecoClick(evt){
      const btn = evt.target.closest('.add-to-calendar');
      if (!btn) return;
      if (Date.now() < gkAddDedupUntil) { evt.preventDefault(); evt.stopPropagation(); return; }
      gkAddDedupUntil = Date.now() + 1200; // ✅ Langer voor animatie
      evt.preventDefault(); evt.stopPropagation();
      if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
      const { title, img, brand, url, variantId } = scrapeRecoCardData(btn);

      // ✅ Animatie: spin + pulse
      btn.classList.add('adding');

      setTimeout(() => {
        btn.classList.remove('adding');
        btn.classList.add('added');

        setTimeout(() => {
          openModalWithProduct(title, img, brand, url, variantId);

          setTimeout(() => {
            btn.classList.remove('added');
          }, 1500);
        }, 300);
      }, 500);
    }
    document.addEventListener('click', handleRecoClick, true);
  })();

  (function(){
    const onAccountFavoritesPage =
      location.pathname.indexOf('/pages/accountoverzicht') !== -1 ||
      !!document.querySelector('.account-favorites-section');
    if (!onAccountFavoritesPage) return;

    function scrapeFavCardData(btn){
      const card = btn.closest('.fav-product-card') || btn.closest('.fav-product') || btn.parentElement;
      let linkEl = (card && (card.querySelector('a.fav-product-card__link') || card.querySelector('a.fav-product-card_link'))) ||
                   btn.closest('a.fav-product-card__link, a.fav-product-card_link');
      const imgEl   = (card && card.querySelector('img')) || (linkEl && linkEl.querySelector('img'));
      const titleEl = (card && card.querySelector('.fav-product-title, .product-title, .card-title, [data-title]'));
      const brandEl = (card && card.querySelector('.fav-product-vendor, .fav-product-brand, .product-brand, .card-brand, [data-brand]'));
      const title = btn.dataset.title || (titleEl && titleEl.textContent.trim()) || (imgEl && imgEl.alt && imgEl.alt.trim()) || 'Product';
      const img   = btn.dataset.img   || (imgEl && (imgEl.currentSrc || imgEl.src)) || '';
      const brand = btn.dataset.brand || (brandEl && brandEl.textContent.trim()) || '';
      const url   = btn.dataset.url   || (linkEl && linkEl.href) || '#';
      const variantId = btn.dataset.variantId || undefined;
      return { title, img, brand, url, variantId };
    }

    function handleAccountFavToCalendar(evt){
      const btn = evt.target.closest('.fav-add-to-calendar');
      if (!btn) return;
      if (Date.now() < gkAddDedupUntil) { evt.preventDefault(); evt.stopPropagation(); return; }
      gkAddDedupUntil = Date.now() + 1200; // ✅ Langer voor animatie
      evt.preventDefault(); evt.stopPropagation();
      if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
      const { title, img, brand, url, variantId } = scrapeFavCardData(btn);

      // ✅ Animatie: spin + pulse
      btn.classList.add('adding');

      setTimeout(() => {
        btn.classList.remove('adding');
        btn.classList.add('added');

        setTimeout(() => {
          openModalWithProduct(title, img, brand, url, variantId);

          setTimeout(() => {
            btn.classList.remove('added');
          }, 1500);
        }, 300);
      }, 500);
    }

    document.addEventListener('click', handleAccountFavToCalendar, true);
  })();

  document.addEventListener('click', function(ev){
    if (Date.now() < suppressClickUntil) {
      if (ev.target.closest('.geurkalender-slot')) { ev.preventDefault(); ev.stopPropagation(); }
    }
  }, true);

  function showDragHintIfNeeded() {
    try {
      if (localStorage.getItem(HINT_KEY) === '1') return;
      const header = modal.querySelector('.geurkalender-header') || modal;
      const hint = document.createElement('div');
      hint.className = 'gk-drag-hint';
      hint.innerHTML = 'Tip: houd een kaartje ingedrukt en <strong>sleep</strong> om te wisselen.';
      header.appendChild(hint);
      requestAnimationFrame(()=>{ hint.classList.add('show'); });
      setTimeout(()=>{ hint.classList.remove('show'); setTimeout(()=>hint.remove(), 400); }, 3500);
      localStorage.setItem(HINT_KEY, '1');
    } catch(_) {}
  }

  document.addEventListener('gk:months-updated', function(e){
    try{
      if (Date.now() < ignoreExternalUntil) return;
      if (inflight || dirty) return;

      const detail = e.detail;
      const months = Array.isArray(detail) ? detail : (detail && detail.months);
      const evtISO = (detail && detail.updatedAt) || null;
      const evtMS  = tsNum(evtISO);
      if (!months || !evtMS) return;

      if (evtMS > lastServerUpdatedAtMS) {
        geurkalender = months.slice(0, 12).map(sanitizeItem);
        lastServerUpdatedAtISO = evtISO; lastServerUpdatedAtMS = evtMS; writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
        saveKalender(false); renderKalender();
      }
    }catch(_){}
  });

  window.addEventListener('visibilitychange', function(){ 
    if (document.visibilityState === 'visible') {
      // 🔥 CHECK: Moet cache gerefresht worden?
      if (IS_SUBSCRIBER && checkIfShouldRefreshLabels()) {
        calLog('[VISIBILITY] Clearing cache - lock window detected');
        clearCachedLabels();
        labelsPreloaded = false;
      }
      refreshFromServer(); 
    }
  });
  
  window.addEventListener('focus', function(){ 
    if (IS_SUBSCRIBER && checkIfShouldRefreshLabels()) {
      calLog('[FOCUS] Clearing cache - lock window detected');
      clearCachedLabels();
      labelsPreloaded = false;
    }
    refreshFromServer(); 
  });
  
  window.addEventListener('beforeunload', function(e) {
    if (dirty && SERVER_OK && !inflight) {
      try {
        const snapshot = (geurkalender || []).slice(0,12).map(sanitizeItem);
        const currentVersion = parseInt(localStorage.getItem(`gk_version_${CUSTOMER_ID}`) || '0');
        const payload = JSON.stringify({
          customer_id: CUSTOMER_ID,
          months: snapshot,
          clientUpdatedAt: lastServerUpdatedAtISO || null,
          version: currentVersion  // 🔥 FIX: Version meesturen voor server-side check
        });

        (async () => {
          try {
            const headers = await getAuthHeaders();
            fetch(API_BASE + '/calendar/save', {
              method: 'POST',
              headers: headers,
              body: payload,
              keepalive: true,
            }).catch(() => {
              const blob = new Blob([payload], { type: 'text/plain;charset=UTF-8' });
              navigator.sendBeacon(API_BASE + '/calendar/save', blob);
            });
          } catch(e) {
            calError('[SAVE] Error getting auth headers:', e);
          }
        })();
      } catch(_) {}
    }
  });
  
  document.addEventListener('turbolinks:before-visit', function() {
    if (dirty && SERVER_OK && !inflight) {
      pushServerNow();
    }
  });
  
  window.addEventListener('pagehide', function(){
    if (dirty && SERVER_OK && !inflight) {
      try {
        const snapshot = (geurkalender || []).slice(0,12).map(sanitizeItem);
        const currentVersion = parseInt(localStorage.getItem(`gk_version_${CUSTOMER_ID}`) || '0');
        const payload = JSON.stringify({
          customer_id: CUSTOMER_ID,
          months: snapshot,
          clientUpdatedAt: lastServerUpdatedAtISO || null,
          version: currentVersion  // 🔥 FIX: Version meesturen voor server-side check
        });

        (async () => {
          try {
            const headers = await getAuthHeaders();
            fetch(API_BASE + '/calendar/save', {
              method: 'POST',
              headers: headers,
              body: payload,
              keepalive: true
            }).catch(() => {});
          } catch(e) {
            calError('[SAVE] Error getting auth headers:', e);
          }
        })();
      } catch(_) {}
    }
  });

  /* ======================== VERSION CHECKING ======================== */
async function ensureFreshCalendarData() {
  if (!IS_SUBSCRIBER) return false;
  
  const now = Date.now();
  const localVersion = parseInt(localStorage.getItem(`gk_version_${CUSTOMER_ID}`) || '0');
  
  // Use cached version if recent (<1 min)
  if (cachedVersion !== null && (now - lastVersionCheck) < VERSION_CACHE_TTL) {
    if (cachedVersion === localVersion) {
      return false; // Already fresh
    }
  }
  
  try {
    // Lightweight version check
    const headers = await getCacheHeaders();
    const versionResp = await fetch(
      `${API_BASE}/calendar/version?customer_id=${CUSTOMER_ID}&cycle=${window.smCustomerCycle || '15'}&_=${now}`,
      { cache: 'no-store', headers: headers }
    );
    
    if (!versionResp.ok) return false;
    
    const versionData = await versionResp.json();
    const serverVersion = versionData.version || 0;
    
    // Update cache
    cachedVersion = serverVersion;
    lastVersionCheck = now;
    
    if (serverVersion > localVersion) {
      calLog(`[VERSION] Refreshing calendar (${localVersion} → ${serverVersion})`);

      // Fetch fresh calendar data
      const headers2 = await getCacheHeaders();
      const dataResp = await fetch(
        `${API_BASE}/calendar?customer_id=${CUSTOMER_ID}&_=${now}`,
        { cache: 'no-store', headers: headers2 }
      );
      
      if (!dataResp.ok) return false;
      
      const calData = await dataResp.json();
      
      // Update global state
      geurkalender = (calData.months || []).slice(0, 12).map(sanitizeItem);
      localStorage.setItem(`gk_version_${CUSTOMER_ID}`, String(serverVersion));
      writeLocal(ACTIVE_KEY, geurkalender);
      
      if (Array.isArray(calData.labels)) {
        window.gkServerLabels = calData.labels;
        writeCachedLabels(calData.labels);
        labelsPreloaded = true;
      }
      
      if (calData.updatedAt) {
        lastServerUpdatedAtISO = calData.updatedAt;
        lastServerUpdatedAtMS = tsNum(calData.updatedAt);
        writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
      }
      
      // Trigger event
      try {
        document.dispatchEvent(new CustomEvent('gk:version-updated', { 
          detail: { version: serverVersion, months: geurkalender } 
        }));
      } catch(_) {}
      
      return true; // Was updated
    }
    
    return false; // Already fresh
  } catch (e) {
    calError('[VERSION] Check failed:', e);
    return false;
  }
}


  /* ======================== 🔥 INIT MET LABEL PRELOADING ======================== */
  // geurkalender.js - UPDATE initCalendar (rond regel 1000)

// geurkalender.js - REPLACE initCalendar

(async function initCalendar() {
    let forceRefresh = false;

    // 0️⃣ HARD CHECK (NIEUW): Is data verlopen op basis van datum?
    if (IS_SUBSCRIBER && isLocalDataExpired()) {
        calLog('[INIT] ⚠️ Data expired by date check - Clearing cache');
        localStorage.removeItem(ACTIVE_KEY);
        localStorage.removeItem(`gk_version_${CUSTOMER_ID}`);
        forceRefresh = true;
    }

    // 1️⃣ Voor subscribers: Check version
    if (IS_SUBSCRIBER && SERVER_OK && !forceRefresh) {
      try {
        const headers = await getCacheHeaders();
        const versionResp = await fetch(
          `${API_BASE}/calendar/version?customer_id=${CUSTOMER_ID}&t=${Date.now()}`,
          { cache: 'no-store', headers: headers }
        );

        if (versionResp.ok) {
          const versionData = await versionResp.json();
          const serverVersion = versionData.version || 0;
          const localVersion = parseInt(localStorage.getItem(`gk_version_${CUSTOMER_ID}`) || '0');

          if (serverVersion > localVersion) {
            calLog('[INIT] Version mismatch - refreshing...');
            forceRefresh = true;
          } else {
             geurkalender = readLocal(ACTIVE_KEY);
          }
        }
      } catch (e) {
        geurkalender = readLocal(ACTIVE_KEY);
      }
    } else if (!forceRefresh) {
      geurkalender = readLocal(ACTIVE_KEY);
      if (!IS_SUBSCRIBER && LABELS_CACHE_KEY) {
        try { sessionStorage.removeItem(LABELS_CACHE_KEY); } catch(_) {}
      }
    }

    // 2️⃣ Als refresh nodig is, haal verse data
    if (forceRefresh && SERVER_OK) {
        calLog('[INIT] Fetching fresh data form server...');
        const headers2 = await getCacheHeaders();
        try {
            const dataResp = await fetch(
              `${API_BASE}/calendar?customer_id=${CUSTOMER_ID}&_=${Date.now()}`,
              { cache: 'no-store', headers: headers2 }
            );
            
            if (dataResp.ok) {
              const data = await dataResp.json();
              geurkalender = (data.months || []).slice(0, 12).map(sanitizeItem);
              
              if (data.version) localStorage.setItem(`gk_version_${CUSTOMER_ID}`, String(data.version));
              
              if (data.updatedAt) {
                  lastServerUpdatedAtISO = data.updatedAt;
                  lastServerUpdatedAtMS = tsNum(data.updatedAt);
                  writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
              }
              
              writeLocal(ACTIVE_KEY, geurkalender);
              if (data.labels) {
                window.gkServerLabels = data.labels;
                writeCachedLabels(data.labels);
              }
            }
        } catch(e) {}
    }

    // 3️⃣ Render
    renderKalender();

    // 4️⃣ Background taken
    if (!IS_SUBSCRIBER) await attemptMergeGuestIntoUser();

    if (SERVER_OK) {
      if (!forceRefresh) refreshFromServer();
      loadGiftBlockStatus();
    }

    if (location.hash === '#geurkalender') {
      try { history.replaceState(history.state && { ...history.state, gkOpen: false }, '', location.pathname + location.search); } catch(e) {}
    }
})();
});
